import { cn } from '@creator/ui/utils/ui';
import ApproveOrDeleteButtons, { type ApproveOrDeleteButtonsProps } from '@src/basic-components/ApproveOrDeleteButtons/ApproveOrDeleteButtons';
import { getUserId } from '@src/model/user/helpers';
import { approvePost } from '@src/store/posts/approve';
import type { FC, PropsWithChildren } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface PendingPostApproveDeleteProps {
    className?: string;
    postId: string;
}

const PendingPostApproveDelete: FC<PropsWithChildren<PendingPostApproveDeleteProps>> = props => {
    const { postId, className = '' } = props;

    const [isApproving, setIsApproving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { t } = useTranslation();

    function mapError(error) {
        alert(`${t('generalErrorMessage')} ${error.message}`);
    }

    async function onApprovePostClick(postId: string, isApprove: boolean): Promise<void> {
        isApprove ? setIsApproving(true) : setIsDeleting(true);

        try {
            const post = await approvePost({
                approve: isApprove,
                postId,
                userId: getUserId(),
            });

            isApprove ? setIsApproving(false) : setIsDeleting(false);
        } catch (error) {
            mapError(error);
            isApprove ? setIsApproving(false) : setIsDeleting(false);
            console.error(error);
        }
    }

    function renderApproveOrDeleteButtons() {
        const props: ApproveOrDeleteButtonsProps = {
            className: cn('', className),
            approveButtonProps: {
                isLoading: isApproving,
                onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onApprovePostClick(postId, true);
                },
            },
            deleteButtonProps: {
                isLoading: isDeleting,
                onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onApprovePostClick(postId, false);
                },
            },
        };
        return <ApproveOrDeleteButtons {...props} />;
    }

    return renderApproveOrDeleteButtons();
};

export default PendingPostApproveDelete;
